import type { HTMLProps } from "react";
import { forwardRef } from "react";
import classNames from "classnames";
import { Check } from "../Icon/Icon";
import styles from "./Radio.module.scss";

const Radio = forwardRef<
  Omit<HTMLInputElement, "ref">,
  HTMLProps<HTMLInputElement>
>(function Radio({ className, ...rest }, ref) {
  return (
    <div className={classNames(styles.radioWrapper, className)}>
      <input {...rest} className={styles.radio} ref={ref} type="radio" />
      {rest.checked ? <Check className={styles.icon} size="xsmall" /> : null}
    </div>
  );
});

export default Radio;
